/*
  Forcast returns portal routing.

  Refundid holds Forcast returns in two stores. Legacy-platform orders are
  zero-padded to nine digits (e.g. "000331391") and run up to 331391; Shopify
  orders are unpadded and start at 170000. The two numeric ranges overlap, so
  the leading zero is what tells them apart. The shopper only knows their
  order number, so this reads it, picks the matching portal, and forwards the
  order number and email on as query params so Refundid can open the return
  already filled in.
*/
(function () {
  var SOURCE = 'returns_policy';

  var LEGACY_PORTAL_URL = 'https://portal.refundid.com/stores/forcast';
  var SHOPIFY_PORTAL_URL = 'https://portal.refundid.com/stores/forcast-au';
  var SHOPIFY_FIRST_ORDER_NUMBER = 170000;

  function normalize(raw) {
    return (raw || '')
      .trim()
      .toUpperCase()
      .replace(/^\s*#\s*/, '')
      .replace(/\s+/g, '');
  }

  // Shoppers paste order numbers in every shape ("#12345", "FC12345 "), so
  // route on the first run of digits rather than on the string as given.
  function extractOrderDigits(order) {
    var match = (order || '').match(/(\d+)/);
    return match ? match[1] : null;
  }

  function pickPortalUrl(digits) {
    // A leading zero only ever appears on zero-padded legacy order numbers.
    if (digits.charAt(0) === '0') return LEGACY_PORTAL_URL;

    var numericOrder = parseInt(digits, 10);
    return numericOrder >= SHOPIFY_FIRST_ORDER_NUMBER ? SHOPIFY_PORTAL_URL : LEGACY_PORTAL_URL;
  }

  function init(root) {
    var form = root.querySelector('[data-returns-portal-form]');
    var errorBox = root.querySelector('[data-returns-portal-error]');

    if (!form) return;

    function showError() {
      if (errorBox) errorBox.hidden = false;
    }

    function hideError() {
      if (errorBox) errorBox.hidden = true;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideError();

      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

      var orderRaw = form.elements.orderNumber.value || '';
      var emailRaw = form.elements.email.value || '';

      var digits = extractOrderDigits(normalize(orderRaw));

      if (!digits) {
        showError();
        return;
      }

      var url = new URL(pickPortalUrl(digits));

      url.searchParams.set('orderNumber', orderRaw.trim());
      url.searchParams.set('email', emailRaw.trim());
      url.searchParams.set('source', SOURCE);

      window.location.href = url.toString();
    });
  }

  document.querySelectorAll('[data-returns-portal]').forEach(init);
})();
